import React from "react";

export default function Graph_Canvas() {
  return (
    <div>
      <h1>Graph_Canvas</h1>
      <p>This is the Graph_Canvas component.</p>
    </div>
  );
}
